export function init(cb) {
  cb && cb();
}

function loadScript(src, async = true) {
  const $script = document.createElement('script');
  $script.async = async;
  $script.src = src;
  document.body.appendChild($script);
  return new Promise((resolve, reject) => {
    $script.onload = () => {
      resolve(true);
    };
  });
}

export function getLocation(cb) {
  cb && cb();
}

export function choosePhoto(cb) {
  // H5 环境下使用浏览器文件选择
  const input = document.createElement('input');
  input.type = 'file';
  input.accept = 'image/*';
  input.onchange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        cb && cb({
          success: true,
          data: event.target.result
        });
      };
      reader.onerror = () => {
        cb && cb({
          success: false,
          message: '读取文件失败'
        });
      };
      reader.readAsDataURL(file);
    }
  };
  input.click();
}
